<script>
import BaseSelectFilter from '@/modules/_global/_components/filters/BaseSelectFilter.vue';
import { mapCacheActions } from 'vuex-cache';

export default {
  name: 'TypesFilter',

  extends: BaseSelectFilter,

  methods: {
    ...mapCacheActions('building_complex', ['getTypes']),

    getData() {
      return this.getTypes().then(({ data }) => {
        return data.data;
      });
    }
  }
};
</script>
